import React from 'react';
import styled from 'styled-components';
import PhoneInputLib from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

interface CustomPhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  name: string;
  label: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  secondary?: boolean;
}

const InputContainer = styled.div`
  margin-bottom: 20px;
  width: 100%;
`;

const InputLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
`;

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;

const StyledPhoneInput = styled.div<{ secondary?: boolean }>`
  width: 100%;
  
  .PhoneInput {
    width: 100%;
    position: relative;
  }
  
  /* Full width input styling */
  .PhoneInputInput {
    width: 100%;
    padding: 14px;
    padding-left: 65px; /* Make room for the flag and country code */
    font-size: 16px;
    border: none;
    border-radius: 12px;
    background: ${props => props.secondary ? '#f5f5f5' : 'white'};
    font-family: 'Montserrat', sans-serif;
    outline: none;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    color: #333;
  }
  
  /* Position the country selector inside the input field */
  .PhoneInputCountry {
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
    z-index: 1;
    display: flex;
    align-items: center;
  }
  
  /* Adjust sizing of the flag icon */
  .PhoneInputCountryIcon {
    width: 24px;
    height: 18px;
  }
  
  /* Reduce size of the dropdown arrow */
  .PhoneInputCountrySelectArrow {
    width: 8px;
    margin-left: 5px;
  }
`;

const ErrorText = styled.p`
  color: #e53935;
  margin-top: 6px;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
`;

const CustomPhoneInput: React.FC<CustomPhoneInputProps> = ({
  value,
  onChange,
  placeholder,
  name,
  label,
  required,
  error,
  disabled,
  secondary
}) => {
  const handleChange = (newValue: string | undefined) => {
    onChange(newValue || '');
  };
  return (
    <InputContainer>
      <InputLabel htmlFor={name}>
        {label} {required && <span style={{ color: '#e53935' }}>*</span>}
      </InputLabel>
      <InputWrapper>
        <StyledPhoneInput secondary={secondary}>
          <PhoneInputLib
            id={name}
            name={name}
            international
            defaultCountry="US"
            value={value}
            onChange={handleChange}
            placeholder={placeholder || "Phone Number"}
            disabled={disabled}
          />
        </StyledPhoneInput>
      </InputWrapper>
      {error && <ErrorText>{error}</ErrorText>}
    </InputContainer>
  );
};

export default CustomPhoneInput;